export const isSelectedMethodConfigDisabled = (method: Method, config: Config[]): boolean => {
    const methodConfig = config.find(item => item.name === method?.id?.split('_')[0])

    return methodConfig ? methodConfig?.enabled ? false : true : false
}

export const isPaymentEnabled = (config: PaymentMethodConfig = { enabled: false }, country?: string, condition?: boolean): boolean => {
    const { enabled, enableIn } = config
    const configEnabled = enabled && (enableIn && country ? enableIn.includes(country) : true)

    return typeof condition !== 'undefined' ? condition && configEnabled : configEnabled
}

interface Method {
    id: string,
}

interface Config {
    name: string,
    enabled: boolean
}

interface PaymentMethodConfig {
    enabled: boolean,
    enableIn?: string[]
}